module.exports = __webpack_public_path__ + "media/images/icon-carrot-left-263d51468dd551cffb9c00f7fa425a18.svg";